import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";
export const MyOrdersIcon: FC<
  DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (

    <svg
    className={className}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M15.7161 16.2234H8.49609"
    stroke="#200E32"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M15.7161 12.0369H8.49609"
    stroke="#200E32"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.2511 7.86008H8.49609"
    stroke="#200E32"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.9085 2.74979C15.9085 2.74979 8.23149 2.75379 8.21949 2.75379C5.45949 2.77079 3.75049 4.58679 3.75049 7.35679V16.5528C3.75049 19.3368 5.47249 21.1598 8.25649 21.1598C8.25649 21.1598 15.9325 21.1568 15.9455 21.1568C18.7055 21.1398 20.4155 19.3228 20.4155 16.5528V7.35679C20.4155 4.57279 18.6925 2.74979 15.9085 2.74979Z"
    stroke="#200E32"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>


);

